/* eslint-disable */

const MONTHS = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];

/**
 * QC-style date: D/Mon/YY (e.g. "14/Apr/26")
 * Used in emails, QC views, delivery blocks.
 * @param {string|Date} iso — ISO string or Date, or YYYY-MM-DD
 * @param {string} fallback — returned when input is falsy (default: '')
 */
export function fmtDate(iso, fallback = '') {
  if (!iso) return fallback;
  const dt = new Date(iso);
  if (isNaN(dt.getTime())) return fallback;
  return `${dt.getDate()}/${MONTHS[dt.getMonth()]}/${String(dt.getFullYear()).slice(2)}`;
}

/**
 * QC-style datetime: DD/Mon/YY HH:MM (e.g. "14/Apr/26 09:30")
 */
export function fmtDateTime(iso) {
  if (!iso) return '';
  const d = new Date(iso);
  if (isNaN(d.getTime())) return '';
  const dd = String(d.getDate()).padStart(2, '0');
  const hh = String(d.getHours()).padStart(2, '0');
  const mm = String(d.getMinutes()).padStart(2, '0');
  return `${dd}/${MONTHS[d.getMonth()]}/${String(d.getFullYear()).slice(2)} ${hh}:${mm}`;
}

/**
 * Dev card date: DD.MM.YY (e.g. "14.04.26")
 */
export function formatDate(dateStr) {
  if (!dateStr) return '';
  try {
    const d = new Date(dateStr);
    const dd = String(d.getDate()).padStart(2, '0');
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    const yy = String(d.getFullYear()).slice(2);
    return `${dd}.${mm}.${yy}`;
  } catch { return ''; }
}

/**
 * Sales-style date: DD Mon YYYY (e.g. "14 Apr 2026")
 * Expects YYYY-MM-DD input string.
 */
export function fmtDateLong(d) {
  return d ? new Date(d + 'T00:00:00').toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' }) : '\u2014';
}
